import React, { useEffect, useState } from 'react';
import { Avatar } from 'react-chat-elements';
import { useSelector } from 'react-redux';
import DEFAULT_AVATAR from '../../../assets/img/avatar.png';
import { getProfileImage } from '../../../utils';

const UpdatedAvatar = ({ currentUser, onlineUsers }) => {
    const [avatar, setAvatar] = useState(DEFAULT_AVATAR);

    useEffect(() => {
        if (currentUser?.image) {
            getProfileImage({ profileImg: currentUser?.image })
                .then((url) => setAvatar(url))
                .catch(() => setAvatar(DEFAULT_AVATAR));
        } else {
            setAvatar(DEFAULT_AVATAR);
        }
    }, [currentUser.image]);

    return (
        <span title={`${onlineUsers.includes(currentUser?.id) ? 'Online' : 'Offline'}`}>
            <Avatar
                src={avatar}
                alt={currentUser?.full_name}
                type='circle'
                size={'small'}
                sideElement={
                    <span className={`user-online-status-customer ${onlineUsers?.includes(currentUser?.id) ? 'online' : 'offline'}`}></span>
                }
            />
        </span>
    );
};

export const CustomerChatHeader = ({ onClose }) => {
    const currentUser = useSelector((s) => s.chat?.selectedUser);
    const onlineUsers = useSelector((s) => s.chat.onlineUsers);

    return (
        <>
            <div className='chat-header'>
                <span className='d-flex align-items-center gap-3 justify-item-start'>
                    <UpdatedAvatar currentUser={currentUser} onlineUsers={onlineUsers} />
                    <div className='d-flex flex-column h-100 ms-1 fw-medium'>
                        <span className='d-flex align-items-center gap-1'>
                            <span>{currentUser?.full_name}</span>
                            <span className='text-mute'>({currentUser?.role_name})</span>
                        </span>
                        {/* <span style={{ fontSize: '11px' }} className='text-mute'>
                            {formatDate(currentUser?.last_logged_in_at)}
                        </span> */}
                    </div>
                </span>

                <button className='btn-close' onClick={onClose} />
            </div>
        </>
    );
};
